import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import { RoleUserListItem } from '../../../../shared/user/roles';
import { UserProfilePicture } from '../../../components/UserProfilePicture';
import { Role } from '../../../models';
import { useTranslation } from '../../../translations';
import { Fetcher, renderName, useFetcher } from '../../../utils';

interface RoleUserListProps {
  readonly role: Role;
}

export const RoleUserList: FC<RoleUserListProps> = ({ role }) => {
  const { ts } = useTranslation();
  const getConventionId = ({ conventionIds }: RoleUserListItem): React.JSX.Element | null => {
    const notGlobal = conventionIds.filter((t) => t !== 0);
    if (notGlobal.length === 0) {
      return null;
    }

    return (
      <span>
        ({ts('convention')}: {notGlobal.join(', ')})
      </span>
    );
  };

  const fetcher = useFetcher(async () => await api.getRoleUsers(role.id), [role.id]);

  if (!fetcher.data) {
    return <Fetcher result={fetcher} />;
  }

  return fetcher.data.map((user) => (
    <div className="search-item" id={`viewUser_${user.id}`} key={user.id}>
      <Link to={`/housekeeping/attendees/user/${user.id}`}>
        <Col className="userListItem clearfix-after" xs={12}>
          <UserProfilePicture url={user.profilePictureUrl} />
          <div>{renderName(user)}</div>
          <div>
            {user.username} {getConventionId(user)}
          </div>
        </Col>
      </Link>
      <hr />
    </div>
  ));
};
